import { Button, Form, Input, Modal } from "antd";
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { pickAFileSliceDispatch, serviceModalSliceDispatch } from "../../Constants/ReduxConstants";
import { ReduxHelpers } from "../../Helpers/ReduxHelpers";

function ServiceModal({ caption }: { caption?: any }) {
    const currentServices = useSelector((state: any) => state.pickAFile.serviceList);
    const currentServiceQuestions = useSelector((state: any) => state.pickAFile.serviceQuestions);
    const currentServiceQuestionBrand = useSelector((state: any) => state.pickAFile.serviceBrandQuestions);

    const open = useSelector((state: any) => state.serviceModal.open);
    const serviceToAdd = useSelector((state: any) => state.serviceModal.serviceToAdd);

    const addModal = useSelector((state: any) => state.serviceViewer.addModal);
    const editModal = useSelector((state: any) => state.serviceViewer.editModal);
    const currentService = useSelector((state: any) => state.serviceViewer.currentService);

    const serviceQuestions = useSelector((state: any) => state.pickAFile.serviceQuestions);

    const dispatch = useDispatch()

    const { CreateContentsFromStates } = ReduxHelpers();

    let serviceValuesToShow = serviceToAdd;

    let adder = AddAService;
    let editor = EditAService;
    let buttonCaption = caption;

    let currentServiceIds = currentServices.map(b => {
        return b.serviceId;
    });

    const onSubmit = () => {
        //We are adding a new one
        if (addModal) {
            adder(null, serviceToAdd)
        }

        //We are editing one
        if (editModal) {
            editor(currentService.serviceId, serviceToAdd)
        }

        dispatch({ type: serviceModalSliceDispatch.setOpen, payload: false })
    }

    const onCancel = () => {
        dispatch({ type: serviceModalSliceDispatch.setOpen, payload: false })
    }

    const onChange = (event) => {
        //NOTE: Change serviceIds to integers
        let valueToUse = event.target.value;
        if (event.target.id == "serviceId") {
            valueToUse = parseInt(event.target.value);
        }

        dispatch({ type: serviceModalSliceDispatch.setServiceToAdd, payload: { ...serviceToAdd, [event.target.id]: valueToUse } })
    }

    function AddAService(oldList, newService) {
        let listToUse = [];
        if (oldList) {
            listToUse = oldList ?? listToUse;
        } else {
            listToUse = currentServices ?? listToUse
        }

        listToUse.push(newService)
        dispatch({ type: pickAFileSliceDispatch.setServiceList, payload: listToUse })

        let tempServiceDropDownList = listToUse?.map(b => {
            return ({ key: b.serviceId, label: b.serviceName, value: b.serviceId })
        })
        dispatch({ type: pickAFileSliceDispatch.setServiceDropDownList, payload: tempServiceDropDownList })

        CreateContentsFromStates({ serviceList: listToUse });
    }

    function EditAService(oldServiceId, newService) {
        let filteredServices = DeleteAService(oldServiceId, false)
        AddAService(filteredServices, newService)

        let updatedServiceQuestions = serviceQuestions.map(x => x.assistanceServiceId == oldServiceId ? { ...x, ['assistanceServiceId']: newService.serviceId } : x);
        dispatch({ type: pickAFileSliceDispatch.setServiceQuestions, payload: updatedServiceQuestions });

        let updatedQuestionServiceBrands = currentServiceQuestionBrand.map(x => x.assistanceServiceId == oldServiceId ? { ...x, ['assistanceServiceId']: newService.serviceId } : x);
        dispatch({ type: pickAFileSliceDispatch.setServiceBrandQuestions, payload: updatedQuestionServiceBrands });
    }

    function DeleteAService(idToDelete, updateState: boolean = true) {

        let filteredServices = currentServices.filter(service => service.serviceId != parseInt(idToDelete) ||
            service.serviceId != idToDelete);

        let filteredServiceQuestionBrands = currentServiceQuestionBrand;
        filteredServiceQuestionBrands = filteredServiceQuestionBrands.filter(sqb => sqb.assistanceServiceId != parseInt(idToDelete))

        let filteredServiceQuestions = currentServiceQuestions;
        filteredServiceQuestions = filteredServiceQuestions.filter(sqb => sqb.assistanceServiceId != parseInt(idToDelete))

        if (updateState) {
            dispatch({ type: pickAFileSliceDispatch.setServiceList, payload: filteredServices })
            //Delete any serviceQuestionBrand entries containing this brand
            dispatch({ type: pickAFileSliceDispatch.setServiceBrandQuestions, payload: filteredServiceQuestionBrands })
            dispatch({ type: pickAFileSliceDispatch.setServiceQuestions, payload: filteredServiceQuestions })
            CreateContentsFromStates({ serviceList: filteredServices, serviceQuestions: filteredServiceQuestions, serviceBrandQuestions: filteredServiceQuestionBrands });
        }

        return filteredServices;

    }

    return (
        <Modal
            title="Service Details"
            footer={null}
            closable={false}
            open={open}
            destroyOnHidden={true}
            onCancel={onCancel}>
            <Form
                onFinish={onSubmit}
                preserve={false}
                initialValues={{
                    ["Service ID"]: serviceValuesToShow.serviceId,
                    ["Service Name"]: serviceValuesToShow.serviceName
                }}
            >
                <Form.Item rules={[{ required: true }, {
                    validator(rule, value) {
                        return new Promise((resolve, reject) => {
                            if (addModal) {
                                if (currentServiceIds?.filter(x => x == value).length == 1) {
                                    reject('There is already a service with ID ' + value + '.');
                                }
                                else {
                                    resolve(undefined);
                                }
                            }
                            else if (editModal) {
                                if (currentServiceIds?.filter(x => x == value).length == 1 && currentService.serviceId != value) {
                                    reject('There is already a service with ID ' + value + '.');
                                }
                                else {
                                    resolve(undefined);
                                }
                            }
                            else {
                                resolve(undefined);
                            }
                        })
                    }
                }]} name="Service ID" label="Service ID">
                    <Input id="serviceId" type="number" placeholder='Service ID' defaultValue={serviceValuesToShow.serviceId} onChange={onChange} />
                </Form.Item>
                <Form.Item rules={[{ required: true }]} name="Service Name" label="Service Name">
                    <Input id="serviceName" placeholder='Service Name' defaultValue={serviceValuesToShow.serviceName} onChange={onChange} />
                </Form.Item>
                <div style={{ display: 'flex', justifyContent: 'end', paddingTop: '1em' }}>
                    <Form.Item>
                        <Button onClick={onCancel}>
                            Cancel
                        </Button>
                    </Form.Item>
                    <Form.Item>
                        <Button htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                </div>
            </Form>
        </Modal>
    )
}

export default ServiceModal;